import { render, staticRenderFns } from "./BulkOperationsLista.vue?vue&type=template&id=63a0b38a&scoped=true"
import script from "./BulkOperationsLista.vue?vue&type=script&lang=js"
export * from "./BulkOperationsLista.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a0b38a",
  null
  
)

export default component.exports